import { getBuildingCenter } from "./index210.js";
import { SelectWingButton } from "./index219.js";
import { GetAllBones, GetAllJoints, RG_TYPE } from "@project-rouge/rg-core";
import { getPivot, getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
import { MathUtils } from "three";
import { memo, useMemo } from "react";
import { Line as Line$1, Plane } from "@react-three/drei";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
const WingSelector = memo(({ obj, onSelect, topOffset, readonly }) => {
	const buildings = useMemo(() => getRgObjectsOfType$1(obj, RG_TYPE.Building), [obj]);
	const bonesPerBuilding = useMemo(() => {
		return buildings.map((building) => ({
			building,
			bones: GetAllBones(building.data.anatomy)
		}));
	}, [buildings]);
	return /* @__PURE__ */ jsxs(Fragment, { children: [buildings.map((b) => /* @__PURE__ */ jsx(BuildingCornerCores, {
		building: b,
		topOffset
	}, b.uuid)), bonesPerBuilding.flatMap((b) => b.bones.map((bone) => ({
		building: b.building,
		bone
	}))).map(({ building, bone }) => /* @__PURE__ */ jsx(SelectWingButton, {
		building,
		bone,
		onClick: onSelect,
		topOffset,
		readonly
	}, bone.id))] });
});
WingSelector.displayName = "WingEditorTool";
var BuildingCornerCores = ({ building, topOffset }) => {
	return /* @__PURE__ */ jsx(Fragment, { children: useMemo(() => {
		const joints = GetAllJoints(building.data.anatomy);
		const cornerCores = [];
		for (const child of building.children) {
			if (child.type !== RG_TYPE.Core) continue;
			if (!child.data.isCorner) continue;
			const joint = joints.find((j) => j.id === child.data.jointID);
			const topLevel = Math.max(...joint.bones.map((b) => b.floors)) - 1;
			if (topLevel !== child.data.level) continue;
			const y = getBuildingCenter(building, joint.bones.find((b) => b.floors === topLevel + 1))[1] * 2 + topOffset;
			const position = getPivot([
				.5,
				1,
				.5
			], child);
			position.y = y;
			const rotation = child.rot.map((v) => v * MathUtils.DEG2RAD);
			const size = [child.size[0], child.size[2]];
			cornerCores.push({
				rotation,
				size,
				position: position.toArray()
			});
		}
		return cornerCores;
	}, [building, topOffset]).map(({ position, rotation, size }, i) => /* @__PURE__ */ jsxs("object3D", {
		position,
		rotation,
		children: [/* @__PURE__ */ jsx(Line$1, {
			points: [
				[
					-size[0] * .5,
					0,
					-size[1] * .5
				],
				[
					size[0] * .5,
					0,
					-size[1] * .5
				],
				[
					size[0] * .5,
					0,
					size[1] * .5
				],
				[
					-size[0] * .5,
					0,
					size[1] * .5
				],
				[
					-size[0] * .5,
					0,
					-size[1] * .5
				]
			],
			transparent: true,
			color: "#3B3B5F"
		}), /* @__PURE__ */ jsx("object3D", { children: /* @__PURE__ */ jsx(Plane, {
			args: size,
			rotation: [
				-90 * MathUtils.DEG2RAD,
				0,
				0
			],
			"material-transparent": true,
			"material-opacity": .5
		}) })]
	}, i)) });
};
export { WingSelector };

//# sourceMappingURL=index220.js.map